/**
 * @flow
 */

import React from 'react';
import { useWatch } from 'react-hook-form';
import { find } from 'lodash';
import { Select } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const options = [
    {
        value: 'CASH',
        text: (
            <FormattedMessage
                id="pages.appointments.details.invoice.InvoiceForm.cash"
                defaultMessage="Cash"
            />
        ),
    },
    {
        value: 'CC',
        text: (
            <FormattedMessage
                id="pages.appointments.details.invoice.InvoiceForm.credit_card"
                defaultMessage="Credit Card"
            />
        ),
    },
    {
        value: 'GIFT',
        text: (
            <FormattedMessage
                id="pages.appointments.details.invoice.InvoiceForm.gift_card"
                defaultMessage="Gift Card"
            />
        ),
    },
    {
        value: 'MEMBERSHIP',
        text: (
            <FormattedMessage
                id="pages.appointments.details.invoice.InvoiceForm.membership"
                defaultMessage="Membership"
            />
        ),
    },
];

type PaymentTypeFieldMembershipProps = {
    value: ?string,
    onChange: Function,
    fieldPath: ?string,
    membership: ?Object,
    allServices: ?Array<Object>,
    setInfoVisible: ?Function,
    invoice: ?Array<Object>,
    change: Function,
};

function PaymentTypeFieldMembership({
    value,
    onChange,
    fieldPath,
    membership,
    allServices,
    setInfoVisible,
    invoice,
    change,
    ...rest
}: PaymentTypeFieldMembershipProps) {
    // Read the `entity` and `paymentType` fields from the RHF form context
    const serviceName = fieldPath ? `${fieldPath}.entity` : 'entity';
    const paymentTypeName = fieldPath ? `${fieldPath}.paymentType` : 'paymentType';
    const service = useWatch({ name: serviceName });
    const paymentType = useWatch({ name: paymentTypeName });

    const handleChange = (e, { value: v }) => {
        if (membership) {
            if (membership.service.id === service) {
                if (v !== 'MEMBERSHIP') {
                    const invoiceItem = find(
                        invoice,
                        item => item.entity.id === service,
                    );
                    if (invoiceItem) {
                        change(
                            fieldPath ? `${fieldPath}.price` : 'price',
                            parseFloat(invoiceItem.price).toFixed(2),
                        );
                    }
                } else {
                    change(
                        fieldPath ? `${fieldPath}.price` : 'price',
                        parseFloat(membership.pricePerUse).toFixed(2),
                    );
                }
            }
        } else if (!membership && paymentType === 'MEMBERSHIP') {
            const defaultServiceData = find(allServices, { id: service });
            if (defaultServiceData) {
                change(
                    fieldPath ? `${fieldPath}.price` : 'price',
                    parseFloat(defaultServiceData.price).toFixed(2),
                );
            }
        }

        if (setInfoVisible) {
            setInfoVisible(v === 'MEMBERSHIP');
        }

        onChange(e, { value: v });
    };

    return (
        <Select
            value={value}
            onChange={handleChange}
            options={options}
            {...rest}
        />
    );
}

export default PaymentTypeFieldMembership;
